import React, { useContext, useEffect, useState } from "react";
import HeaderNav from "../components/HeaderNav";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import { Analytics } from "@vercel/analytics/react";
import {
  DropDown,
  Input,
  NormalHeading,
  ToastError,
  ToastSuccess,
} from "../global/component";
import {
  Link,
  Navigate,
  replace,
  useHref,
  useNavigate,
  useRoutes,
} from "react-router";
import FreeTips from "./FreeTips";
import AuthContext from "../global/auth-context";
import { ToastContainer } from "react-toastify";
import { ConvertCodeService } from "../models/ApiService";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { MdContentCopy, MdCancel } from "react-icons/md";
import {
  Dots,
  Levels,
  Sentry,
  Spinner,
  Squares,
  Digital,
  Bounce,
  Windmill,
} from "react-activity";
import "react-activity/dist/library.css";
import CopyToClipboard from "react-copy-to-clipboard";

const Convert = () => {
  const [selectTo, setSelectTo] = useState(false);
  const [selectFrom, setSelectFrom] = useState(false);
  const [to, setTo] = useState(null);
  const [from, setFrom] = useState(null);
  const [ConvertFrom, setConvertFrom] = useState("Select a Bookie");
  const [convertTo, setConvertTo] = useState("Select a Bookie");
  const [searchTo, setSearchTo] = useState(null);
  const [searchFrom, setSearchFrom] = useState(null);
  const [code, setCode] = useState(null);
  const [newCode, setNewCode] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [errors, setErrors] = useState({});
  const [isError, setIsError] = useState(true);
  const [isFormValid, setIsFormValid] = useState(false);
  const [converting, setConverting] = useState(false);
  const [converted, setConverted] = useState(false);

  let { userData, bookies, user, fetchUserData, isAuth } =
    useContext(AuthContext);
  const [filteredFrom, setFilteredFrom] = useState(bookies);
  const [filteredTo, setFilteredTo] = useState(bookies);

  let navigate = useNavigate();

  const validateForm = () => {
    let errors = {};

    // Validate code field
    if (!code) {
      errors.code = "code is required.";
    }

    // Validate from field
    if (!from) {
      errors.from = "Convert To is required.";
    }

    // Validate to field
    if (!to) {
      errors.to = "Convert To is required.";
    }

    // Set the errors and update form validity
    setErrors(errors);
    setIsFormValid(Object.keys(errors).length === 0);
  };

  useEffect(() => {
    validateForm();
  }, [code, from, to]);

  async function ConvertFunction(e) {
    e.preventDefault();
    setSubmit(true);
    if (isFormValid) {
      if (!user) {
        return navigate("/login");
      }

      if (!userData.unit || userData.unit < 1) {
        ToastError("You don't have enough units to convert.");
        navigate("/buy-units");
        window.scrollTo(0, 0);
      }

      setConverting(true);

      let payload = { user, code, from, to };
      console.log("payload", payload);

      let response = await ConvertCodeService(payload);
      if (response.success == true) {
        setConverted(true);
        setConverting(false);
        setNewCode(response.data);
        ToastSuccess("Code converted successfully.");
        fetchUserData(user);
        console.log(response);
      } else {
        setConverting(false);
        ToastError(response.message);
      }
    } else {
      ToastError("Please fill all fields correctly.");
    }
  }

  return (
    <>
      <Analytics />
      {/* {!isAuth ? (
        navigate("/login", { replace: true })
      ) : ( */}
      <div className="flex flex-col justify-between h-full">
        <div>
          <HeaderNav page={"convert"} />
          <Hero>
            <div className="flex flex-col md:px-32 py-5 gap-7 h-full justify-center px-5">
              <div className="flex flex-wrap gap-3 md:gap-7">
                <p className=" text-white font-bold md:text-5xl text-3xl md:w-full">
                  Convert Your
                </p>
                <span className=" text-yellow-400 font-bold md:text-5xl text-3xl">
                  Booking Codes
                </span>
                <span className=" text-white font-bold md:text-5xl text-3xl">
                  Here
                </span>
              </div>
              <p className=" text-white font-normal text-xl md:text-2xl w-2/3">
                Users can get to convert their booking codes from one bookie to
                another.
              </p>
              <p className=" text-white font-normal text-xl md:text-2xl w-2/3">
                <span className=" text-yellow-500 font-normal text-xl">
                  Note:{" "}
                </span>{" "}
                each successful conversion cost 1 unit.
              </p>
            </div>
          </Hero>
          <div className="flex gap-5 flex-wrap bg-myLightGreen w-screen  py-10 overflow-x-hidden">
            <div className="md:flex-1 flex h-fit w-full flex-col mx-5 gap-1 mb-5">
              <div className="flex justify-between px-3 sm:justify-around">
                <text className="md:text-lg font-bold">Code Converter</text>
                <text className="md:text-lg font-bold">
                  {userData.unit} {userData.unit <= 1 ? "unit" : "Units"}
                </text>
              </div>
              <div className="flex p-5 flex-col gap-5 bg-myNormalGreen rounded-md  w-full">
                <div className="bg-white w-full h-32 flex items-center justify-center">
                  <NormalHeading Text={"SLIDER"} />
                </div>

                <div className="flex flex-col gap-5">
                  <div className="flex flex-col gap-1 ">
                    <div className="flex px-3">
                      <NormalHeading
                        Text={"Booking Code"}
                        TextColor={"white"}
                      />
                    </div>
                    <input
                      className="flex h-12 outline-0 w-full px-5 rounded-full"
                      placeholder={"Enter Booking Code"}
                      value={code}
                      onChange={(e) => {
                        setCode(e.target.value);
                      }}
                    />
                  </div>
                  <div className="flex flex-wrap gap-5">
                    {/* convert from */}

                    <div className={`flex flex-col w-full sm:flex-1 `}>
                      <div className="flex px-3">
                        <NormalHeading
                          Text={"Convert From"}
                          TextColor={"white"}
                        />
                      </div>
                      <a
                        className={`${
                          selectFrom ? "" : " rounded-full"
                        } w-full bg-white  relative`}
                      >
                        {selectFrom && (
                          <div className="flex z-50 overflow-y-scroll w-full top-12 flex-col absolute h-72 border-y-2 border-y-myNormalGreen bg-myLightGreen rounded-md">
                            {searchFrom && filteredFrom.length < 1 && (
                              <text className="text-center text-myNormalGreen font-bold py-2">
                                No Bookie Found
                              </text>
                            )}
                            {searchFrom
                              ? filteredFrom.map((item, index) => {
                                  return (
                                    <Link
                                      className="flex px-3 py-2 hover:bg-myNormalGreen hover:text-white"
                                      key={index}
                                      onClick={() => {
                                        setSelectFrom(false);
                                        setSelectTo(false);
                                        setFrom(item.bookie);
                                        setFilteredFrom(bookies);
                                        setConvertFrom(item.name);
                                      }}
                                    >
                                      {item.name}
                                    </Link>
                                  );
                                })
                              : bookies.map((item, index) => {
                                  return (
                                    <Link
                                      className="flex px-3 py-2 hover:bg-myNormalGreen hover:text-white"
                                      key={index}
                                      onClick={() => {
                                        setSelectFrom(false);
                                        setSelectTo(false);
                                        setFrom(item.bookie);
                                        setFilteredFrom(bookies);
                                        setConvertFrom(item.name);
                                      }}
                                    >
                                      {item.name}
                                    </Link>
                                  );
                                })}
                          </div>
                        )}
                        {!selectFrom ? (
                          <Link
                            onClick={() => {
                              setSelectFrom(true);
                              setSelectTo(false);
                            }}
                          >
                            <DropDown
                              Text={ConvertFrom}
                              TextColor={
                                submit && errors.from ? "red" : "black"
                              }
                            />
                          </Link>
                        ) : (
                          <input
                            className="flex h-12 outline-0 w-full px-5"
                            placeholder="Search Bookie"
                            value={searchFrom}
                            onChange={(e) => {
                              setSearchFrom(e.target.value);
                              setFilteredFrom(
                                bookies.filter((item) =>
                                  item.name
                                    .toLowerCase()
                                    .includes(e.target.value.toLowerCase())
                                )
                              );
                            }}
                          />
                        )}
                      </a>
                    </div>

                    {/* convert to */}
                    <div className={`flex flex-col w-full sm:flex-1 `}>
                      <div className="flex px-3">
                        <NormalHeading
                          Text={"Convert To"}
                          TextColor={"white"}
                        />
                      </div>
                      <a
                        className={`${
                          selectTo ? "" : " rounded-full"
                        } w-full bg-white  relative`}
                      >
                        {selectTo && (
                          <div className="flex overflow-y-scroll w-full top-12 flex-col absolute h-72 border-y-2 border-y-myNormalGreen bg-myLightGreen rounded-md">
                            {searchTo && filteredTo.length < 1 && (
                              <text className="text-center text-myNormalGreen font-bold py-2">
                                No Bookie Found
                              </text>
                            )}
                            {searchTo
                              ? filteredTo.map((item, index) => {
                                  return (
                                    <Link
                                      className="flex px-3 py-2 hover:bg-myNormalGreen hover:text-white"
                                      key={index}
                                      onClick={() => {
                                        setSelectFrom(false);
                                        setSelectTo(false);
                                        setTo(item.bookie);
                                        setFilteredTo(bookies);
                                        setConvertTo(item.name);
                                      }}
                                    >
                                      {item.name}
                                    </Link>
                                  );
                                })
                              : bookies.map((item, index) => {
                                  return (
                                    <Link
                                      className="flex px-3 py-2 hover:bg-myNormalGreen hover:text-white"
                                      key={index}
                                      onClick={() => {
                                        setSelectFrom(false);
                                        setSelectTo(false);
                                        setTo(item.bookie);
                                        setFilteredTo(bookies);
                                        setConvertTo(item.name);
                                      }}
                                    >
                                      {item.name}
                                    </Link>
                                  );
                                })}
                          </div>
                        )}
                        {!selectTo ? (
                          <Link
                            onClick={() => {
                              setSelectFrom(false);
                              setSelectTo(true);
                            }}
                          >
                            <DropDown
                              Text={convertTo}
                              TextColor={submit && errors.to ? "red" : "black"}
                            />
                          </Link>
                        ) : (
                          <input
                            className="flex h-12 outline-0 w-full px-5"
                            placeholder="Search Bookie"
                            value={searchTo}
                            onChange={(e) => {
                              setSearchTo(e.target.value);
                              setFilteredTo(
                                bookies.filter((item) =>
                                  item.name
                                    .toLowerCase()
                                    .includes(e.target.value.toLowerCase())
                                )
                              );
                            }}
                          />
                        )}
                      </a>
                    </div>
                  </div>
                  {converted && (
                    <div className="flex flex-col gap-1 bg-myLightGreen py-5 px-3">
                      <Link
                        onClick={() => {
                          setConverted(false);
                        }}
                        className="flex self-end px-2 pb-2"
                      >
                        <MdCancel size={25} color="red" />
                      </Link>
                      <text className="text-center sm:text-xl">
                        Your booking code{" "}
                        <span className="font-bold">{code.toUpperCase()}</span>{" "}
                        has been successfully converted from{" "}
                        <span className="font-bold">
                          {ConvertFrom.toUpperCase()}
                        </span>{" "}
                        to{" "}
                        <span className="font-bold">
                          {convertTo.toUpperCase()}
                        </span>{" "}
                        <br />
                        <br />{" "}
                        <div className="flex justify-center items-center">
                          <IoMdCheckmarkCircleOutline
                            size={50}
                            color="#016401"
                          />
                        </div>
                        <br /> Your new{" "}
                        <span className="font-bold">
                          {" "}
                          {convertTo.toUpperCase()}
                        </span>{" "}
                        booking code is
                      </text>
                      <CopyToClipboard text={newCode}>
                        <Link
                          onClick={() => {
                            ToastSuccess("code copied");
                          }}
                          className="flex self-center bg-myNormalGreen px-3 py-1 mt-5 rounded-full text-white font-bold text-2xl justify-center items-center gap-1"
                        >
                          <text>{newCode.toUpperCase()} </text>
                          <MdContentCopy size={20} color="white" />
                        </Link>
                      </CopyToClipboard>
                    </div>
                  )}
                </div>
              </div>
              <Link
                onClick={ConvertFunction}
                className="flex mt-2 justify-center items-center rounded-full bg-myNormalGreen gap-2"
              >
                <text
                  className={`text-white py-2   ${
                    !converting
                      ? "font-bold text-2xl"
                      : "text-xl text-myLightGreen font-bold"
                  }`}
                >
                  {converting ? "converting" : "CONVERT"}
                </text>

                {converting && <Spinner color="white" size={10} />}
              </Link>
            </div>

            <div className="flex justify-center w-full flex-col items-center  md:flex-1">
              <NormalHeading
                Text={"Free Tips for Today"}
                TextColor={"#016401"}
              />
              <text>
                {new Date().toString().split(" ")[0] +
                  " - " +
                  new Date().toString().split(" ")[1] +
                  " " +
                  new Date().toString().split(" ")[2] +
                  " " +
                  new Date().toString().split(" ")[3]}
              </text>
              <FreeTips />
            </div>
          </div>
        </div>
        <Footer />
      </div>
      {/* )} */}
    </>
  );
};

export default Convert;
